import React from 'react';
import ZombiePurgeContent from '../ContentContainer';
import { ActionButton } from 'src/ui/components';

export default function ZombiePurgeConnectWallet({ connect, className }) {
	return (
    	<ZombiePurgeContent className={className}>
			<div className="flex flex-col items-center justify-center h-full">
				<h3 className='max-[1000px]:text-4xl max-[768px]:text-3xl max-[500px]:text-2xl text-5xl text-center uppercase mb-4'>PLease connect your wallet</h3>
				<ActionButton iconType="fox"
					textContent="connect wallet"
					className="max-[500px]:text-base"
					onClick={connect}/>
			</div>
		</ZombiePurgeContent>
	);
}
